'use strict'

function _instanceof(left, right) {
  if (
    right != null &&
    typeof Symbol !== 'undefined' &&
    right[Symbol.hasInstance]
  ) {
    return !!right[Symbol.hasInstance](left)
  } else {
    return left instanceof right
  }
}

function _classCallCheck(instance, Constructor) {
  if (!_instanceof(instance, Constructor)) {
    throw new TypeError('Cannot call a class as a function')
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i]
    descriptor.enumerable = descriptor.enumerable || false
    descriptor.configurable = true
    if ('value' in descriptor) descriptor.writable = true
    Object.defineProperty(target, descriptor.key, descriptor)
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps)
  if (staticProps) _defineProperties(Constructor, staticProps)
  return Constructor
}

var characterUrl =
  'https://builder.midnightplatform.net/midnight/system/generate/'

var Character = /*#__PURE__*/ (function () {
  function Character(string, brand) {
    var subBrand =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null
    var type =
      arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'web'
    var name =
      arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : ''

    _classCallCheck(this, Character)

    this.character_string = string
    this.date_created = Date.now()
    this.brand = brand
    this.sub_brand = subBrand
    this.type = type
    this.name = name
  }

  _createClass(Character, [
    {
      key: 'setName',
      value: function setName(name) {
        this.name = name
      },
    },
  ])

  return Character
})()

window.preview = (character) =>
  window.dispatchEvent(
    new CustomEvent('preview', {
      detail: character,
    })
  )

const builderId = 'builder'
const previewImage = 'preview'

const getParams = function (url) {
  var params = {}
  var parser = document.createElement('a')
  parser.href = url
  var query = parser.search.substring(1)
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    params[pair[0]] = decodeURIComponent(pair[1])
  }
  return params
}

var characterStorage = (function () {
  /**
   * setup
   * @param {string} brand
   *
   * This function will initialise the localStorage object. It will
   * check to see if the user has any saved characters for the
   * product's brand. If it does the Saved Characters button
   * is shown.
   * Any event listener is setup for when a character is added
   * to the user's cart.
   */
  function setup(brand) {
    syncSession() // retrieve only the characters for the product brand

    var brandCharacters = getCharacters(brand)

    if (brandCharacters.length > 0) {
      $('#edit-character').show()
      $('#saved-characters').show()
    } // setup event listeners

    window.addEventListener('characterStored', function () {
      $('#edit-character').show()
      $('#saved-characters').show()
    })
  }
  /**
   * initialiseCharacter
   *
   * This function will check if a character has been passed via the query string.
   * If a character exists, it takes precendence. Otherwise the system defaults
   * to the user's saved character's or the brand default.
   */

  function initialiseCharacter() {
    var config = getMoonshineConfig()
    if (!config && !document.body.classList.contains('template-account')) return

    var character = checkQueryStringForCharacter()

    const moonshineConfig = getMoonshineConfig()
    if (moonshineConfig && moonshineConfig.hasOwnProperty('parts')) {
      $('#edit-character').hide()
      $('#saved-characters').hide()
    }
    if (character) {
      loadCharacterIntoMoonshine(character)
      characterSelected()
      $('#no-characters').hide()
      $('#edit-product').show()
    } else if (config) {
      window.save ? window.save() : null
      //document.getElementById('preview').src = "https://moonshine-live.midnightplatform.net/".concat(config.brand, "_ghost.png");
      $('#createCharacter').show()

      var sub_brand = []
      if (config.hide_subbrands) sub_brand = config.hide_subbrands
      character = getDefaultCharacter(config.brand, sub_brand)

      if (character && !moonshineConfig.hasOwnProperty('parts')) {
        $('#existing-characters').show()
      }

      //       if (!character || moonshineConfig.hasOwnProperty('parts')) {
      //         document.getElementById('preview').src = "https://moonshine-live.midnightplatform.net/".concat(config.brand, "_ghost.png");
      //         $('#createCharacter').show();
      //         return;
      //       }

      //loadCharacterIntoMoonshine(character.character_string);
      //characterSelected();
    }
  }

  function characterSelected() {
    $('#no-characters').hide()
    $('#edit-product').show()
    $('#existing-characters').hide()

    $('#createCharacter').hide()
    $('#edit-character').show()
    $('div.cBContainer').addClass('finished')
    $('#add-to-cart').removeAttr('disabled')
  }
  /**
   * checkQueryStringForCharacter
   *
   * This function checks the url query string for the presence of a character.
   * If one is found, then this takes precendance over other characters.
   * The resulting character is then returned.
   */

  function checkQueryStringForCharacter() {
    var urlParams = getParams(window.location.href)
    var character = urlParams.character
    if (!character) return //     let [brand, ...options] = character.split('_')
    //     let config = getMoonshineConfig()
    //     if (config.brand !== brand) return

    return character
  }
  /**
   * getDefaultCharacter
   * @param {string} brand
   *
   * This function returns the default character for a brand.
   */

  function getDefaultCharacter(brand) {
    var subBrand =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : []
    var brandCharacters = getCharacters(brand, subBrand)
    brandCharacters = brandCharacters
      .sort(function (a, b) {
        return a.date_created < b.date_created ? 1 : -1
      })
      .filter(function (item) {
        return !subBrand.includes(item.sub_brand)
      })
    if (!brandCharacters[0]) return
    return brandCharacters[0]
  }
  /**
   * loadCharacterIntoMoonshine
   *
   * This function loads the selected character information into the Moonshine builder.
   * It also updates the preview image on the product page.
   * @param {string} character
   */

  function loadCharacterIntoMoonshine(character) {
    // update preview image
    var loadedCharacterImage = ''.concat(characterUrl).concat(character, '.png')

    window.preview(loadedCharacterImage)

    //     if(document.getElementById('preview')) {
    //     	document.getElementById('preview').src = loadedCharacterImage; // load this character into the builder iframe
    //     }

    var contentWindow = document.getElementById(builderId).contentWindow
    contentWindow.postMessage(
      {
        event: 'load',
        key: 'character',
        value: character,
      },
      '*'
    )
  }
  /**
   * syncSession
   *
   * This function syncs the user's current localStorage with their saved characters
   * from their Shopify account.
   */

  function syncSession() {
    console.log('🚀 character_storage.js 253 - syncSession')
    var sessionCharacters = getCharacters()

    var customersSavedCharacters = document.getElementById('saved_characters')
      ? document.getElementById('saved_characters').innerHTML
      : null
    var shopifyCharacters = []

    if (customersSavedCharacters) {
      shopifyCharacters = JSON.parse(customersSavedCharacters, null, 2)
    }

    if (shopifyCharacters !== null) {
      sessionCharacters = sessionCharacters.concat(shopifyCharacters)
    }

    var filteredCharacters = Array.from(
      new Set(
        sessionCharacters.map(function (a) {
          return a.character_string
        })
      )
    ).map(function (string) {
      return sessionCharacters.find(function (a) {
        return a.character_string === string
      })
    })

    console.log('⚽ filteredCharacters:', filteredCharacters)
    storeSavedCharacters(filteredCharacters)
  }
  /**
   * Store saved characters in session storage
   * @param {array} characters
   *
   * This function will save an array of the users saved characters to local storage
   */

  function storeSavedCharacters(characters) {

    // at some point - this array becomes multi-dimentional, can't work out where currently
    // so will just flatten it to prevent the bug (mrt 12/23)

    characters = characters.flat();
    
    console.log('💡 storeSavedCharacters', characters)
    window.sessionStorage.setItem('savedCharacters', JSON.stringify(characters))
    window.dispatchEvent(new CustomEvent('characterStored'))
  }
  /**
   * getCharacters
   *
   * @param {string} brand
   * @param {string} subBrand
   *
   * This function retrieves the list of characters store in localStorage.
   * Once found it will filter out the relevant characters for the product
   * brand and sub_brand.
   *
   * @returns {Array}
   */

  function getCharacters() {
    var brand =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null
    var subBrand =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : []
    var characters = JSON.parse(
      window.sessionStorage.getItem('savedCharacters'),
      null,
      2
    )
    if (characters === null) return []

    if (brand) {
      characters = characters.filter(function (item) {
        return item.brand === brand
      })
    }

    if (subBrand) {
      characters = characters.filter(function (item) {
        return !subBrand.includes(item.sub_brand)
      })
    }

    return characters
  }

  function getAllCharacters() {
    const characters = JSON.parse(sessionStorage.getItem('savedCharacters'))
    return characters
  }

  function storeCharacter(string, brand, subBrand, type) {
    console.log('🚀 character_storage.js 345 - storeCharacter')
    var moonshineConfig = getMoonshineConfig()

    if (moonshineConfig && moonshineConfig.hasOwnProperty('parts')) return

    var options = string.split('_')
    var sub_brand = options[0].replace(/-/g, '_')
    var newCharacter = new Character(string, brand, sub_brand, type)

    if (window.store.get('characterDetails')) {
      const details = window.store.get('characterDetails')
      //iterate and store
      newCharacter.name = details.name
      newCharacter.relationship = details.relationship
      newCharacter.birthday = details.birthday
    }
    var existingCharacters = getCharacters()
    console.log('existingCharacters',existingCharacters);
    var characterExists = existingCharacters.find(function (character) {
      return character.character_string === string
    })

    if (!characterExists) {
      existingCharacters.push(newCharacter)
    }

    storeSavedCharacters(existingCharacters)
    window.dispatchEvent(new CustomEvent('characterStored'))
  }

  function getMoonshineConfig() {
    var config = document.getElementById('moonshine_config_json')
    if (!config) return null
    return JSON.parse(config.innerHTML, null, 2)
  }

  return {
    setup: setup,
    initialiseCharacter: initialiseCharacter,
    storeCharacter: storeCharacter,
    checkQueryStringForCharacter: checkQueryStringForCharacter,
    getCharacters: getCharacters,
    getAllCharacters: getAllCharacters,
    characterSelected: characterSelected,
    getMoonshineConfig: getMoonshineConfig,
  }
})()
